import _ from 'underscore'
import Backbone from 'backbone'
import TextTemplate from '../templates/text.tpl'

const ClassOptionView = Backbone.View.extend({
    tagName: 'option',
    initialize() {
        this.template = _.template(TextTemplate)
    },
    render() {
        this.$el.val(this.model.get('id'))
        if (this.model.get('selected')) {
            this.$el.attr('selected', 'selected')
        }
        this.$el.html(this.template({text: this.model.get('name')}))
        return this
    }
})

export default ClassOptionView